const React = require('react');

const Content = require('../common/Content.jsx');
const Meta = require('../common/Meta.jsx');
const Token = require('../utility/Token.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region NAME

function _Name(props) {
    const data = props.data || {};
    const hasValue = !Utilities.isNullOrWhitespace(data.Name);
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />
}
const Name = Content.withLabelTokenParsing(_Name, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Name:
            if (!Utilities.isNullOrWhitespace(data.Name)) {
                replaceString = data.Name;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensName = () => [{ display: 'Name', token: Token.Name }];
const TypeConfigName = {
    panel: {
        block: Content.TypeConfig.labelValue.panelV2.block,
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: 'PO:'})),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: () => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Name}}`, token: Token.Name }))
    }
};

// #endregion NAME

// #region NUMBER

function _Number(props) {
    const data = props.data || {};
    const hasValue = !Utilities.isNullOrWhitespace(data.Number);
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />
}
const Number = Content.withLabelTokenParsing(_Number, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.PurchaseOrderNumber:
            if (!Utilities.isNullOrWhitespace(data.Number)) {
                replaceString = data.Number;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensNumber = () => [{ display: 'Purchase Order #:', token: Token.PurchaseOrderNumber }];
const TypeConfigNumber = {
    panel: {
        block: Content.TypeConfig.labelValue.panelV2.block,
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: 'Order #:'})),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: () => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.PurchaseOrderNumber}}`, token: Token.PurchaseOrderNumber }))
    }
};

// #endregion NUMBER

// #region STAGE

function _Stage(props) {
    const data = props.data || {};
    const hasValue = data.Stage && !Utilities.isNullOrWhitespace(data.Stage.Name);
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />
}
const Stage = Content.withLabelTokenParsing(_Stage, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Stage:
            if (data.Stage && !Utilities.isNullOrWhitespace(data.Stage.Name)) {
                replaceString = data.Stage.Name;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensStage = () => [{ display: 'Stage:', token: Token.Stage }];
const TypeConfigStage = {
    panel: {
        block: Content.TypeConfig.labelValue.panelV2.block,
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: 'Stage:'})),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: () => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Stage}}`, token: Token.Stage }))
    }
};

// #endregion STAGE

// #region TRACKING NUMBER

function _TrackingNumber(props) {
    const data = props.data || {};
    const hasValue = !Utilities.isNullOrWhitespace(data.TrackingNumber);
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />
}
const TrackingNumber = Content.withLabelTokenParsing(_TrackingNumber, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.TrackingNumber:
            if (!Utilities.isNullOrWhitespace(data.TrackingNumber)) {
                replaceString = data.TrackingNumber;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensTrackingNumber = () => [{ display: 'Tracking Number', token: Token.TrackingNumber }];
const TypeConfigTrackingNumber = {
    panel: {
        block: Content.TypeConfig.labelValue.panelV2.block,
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: 'Tracking Number:'})),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: () => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.TrackingNumber}}`, token: Token.TrackingNumber }))
    }
};

// #endregion TRACKING NUMBER

module.exports = {
    ...Meta,
    Name: {
        Component: Name,
        Tokens: TokensName,
        TypeConfig: TypeConfigName
    },
    Number: {
        Component: Number,
        Tokens: TokensNumber,
        TypeConfig: TypeConfigNumber
    },
    Stage: {
        Component: Stage,
        Tokens: TokensStage,
        TypeConfig: TypeConfigStage
    },
    TrackingNumber: {
        Component: TrackingNumber,
        Tokens: TokensTrackingNumber,
        TypeConfig: TypeConfigTrackingNumber
    }
};